import React from 'react';

function CurrentDay(props) {
    let date = (new Date(props.weather.dt * 1000)).toString().split(' ');
    return(
        <div className="current">
            <div className="day current__info">
                <span>{`${date[0]} ${date[1]} ${date[2]}`}</span>
                <span className="location">City: {props.city} <img alt="'Weather" src={`https://openweathermap.org/img/wn/${props.weather.weather[0].icon}@2x.png`}></img></span>
                <span className="temp__current">{`Temperature: ${props.weather.temp}\u00B0C`}</span>
                <span>{`Feels like: ${props.weather.feels_like}\u00B0C`}</span>
                <span>Cloudiness: {props.weather.clouds} %</span>
                <span>Humidity: {props.weather.humidity} %</span>
                <span>{`Wind speed: ${props.weather.wind_speed} metre/sec`}</span>
            </div>
        </div>
    );
}

export default CurrentDay;